<template>
    <CommandContextMenuButton
        v-if="firstCard.isIn.controlled"
        :command="commands.Flip"
        :closeOnClick="true"
    />

    <ContextMenuButton
        v-if="firstCard.isIn.hand || firstCard.isIn.library || firstCard.isIn.ashHeap"
        :closeOnClick="true"
        :cardAction="
            (card: Card) =>
                gameMutations.playFaceDown.actSelf({
                    card: card,
                })
        "
    >
        Play Face Down
    </ContextMenuButton>

    <CommandContextMenuButton
        v-if="!firstCard.isIn.ashHeap && !firstCard.isIn.removed"
        :command="commands.MoveToAshHeap"
        :closeOnClick="true"
        :hideKeyBinding="gameBus.contextMenu.fromStackRegion"
    >
        <template
            v-if="
                singleCard &&
                (firstCard.isIn.library || firstCard.isIn.crypt) &&
                firstCard == firstCard.region.firstCard
            "
        >
            Burn Top Card
        </template>
        <template v-else-if="firstCard.isIn.hand"> Discard </template>
        <template v-else>
            {{ commands.MoveToAshHeap.label }}
        </template>
    </CommandContextMenuButton>

    <CommandContextMenuButton
        v-if="!firstCard.isIn.uncontrolled && !firstCard.isIn.crypt"
        :command="commands.MoveToLibBottom"
        :closeOnClick="true"
        :hideKeyBinding="gameBus.contextMenu.fromStackRegion"
    >
        Move to Bottom of Library
    </CommandContextMenuButton>

    <CommandContextMenuButton
        v-if="!firstCard.isIn.removed"
        :command="commands.RemoveFromGame"
        :closeOnClick="true"
        :hideKeyBinding="gameBus.contextMenu.fromStackRegion"
    />

    <ContextMenuButton
        v-if="firstCard.isIn.play || firstCard.isIn.crypt"
        :closeOnClick="true"
        :cardAction="
            (card: Card) =>
                players.selfPlayer ?
                    gameMutations.moveToBottom.actSelf({
                        card: card,
                        toCardRegion: players.selfPlayer.crypt,
                    })
                :   null
        "
    >
        Move to Bottom of Crypt
    </ContextMenuButton>

    <ContextMenuButton
        v-if="!isEngine && singleCard && !singleCard.isVampire() && singleCard.isIn.ready"
        :closeOnClick="true"
        :cardAction="
            (card: Card) =>
                gameMutations.becomeVampire.actSelf({
                    card: card,
                })
        "
    >
        Become a vampire
    </ContextMenuButton>

    <ContextMenuButton
        v-if="!isEngine && singleCard && !singleCard.isMinion() && singleCard.isIn.ready"
        :closeOnClick="true"
        :cardAction="
            (card: Card) =>
                gameMutations.becomeMinion.actSelf({
                    card: card,
                })
        "
    >
        Become an ally
    </ContextMenuButton>

    <CommandContextMenuButton
        v-if="firstCard.isIn.play"
        :command="commands.PingCard"
        :closeOnClick="true"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { gameMutations } from '@/shared/state/gameMutations.ts'
import { useGameStateStore } from '@/client/store/gameState.ts'
import { GameType } from '@/shared/types/state.ts'
import { Card } from '@/shared/model/Card.ts'
import CommandContextMenuButton from '@/client/ui/context/menu/CommandContextMenuButton.vue'
import ContextMenuButton from '@/client/ui/context/menu/ContextMenuButton.vue'
import { useGameBusStore } from '@/client/store/bus.ts'
import { usePlayersStore } from '@/client/state/players.ts'
import { useCommands } from '@/client/game/composables/useCommands.ts'
import { useSelection } from '@/client/game/composables/useSelection.ts'

const gameBus = useGameBusStore()
const gameState = useGameStateStore()
// A game with the rules engine : the engine makes a card a minion ( see engine/projection.ts )
const isEngine = computed(() => gameState.gameType == GameType.Engine)
const players = usePlayersStore()
const commands = useCommands()
const { firstCard, singleCard } = useSelection(() => gameBus.contextMenu.cards)
</script>

<style lang="scss"></style>
